module.exports = __webpack_public_path__ + "static/media/optibolt-1.12b95698.jpg";